import { PaymentType } from "../../payment-types/models/PaymentType";
import { PolicySentenceInput } from "../../portal/utils/policySentence";
import { CancellationPolicyValues } from "../components/CancellationPolicyFields";
import { LateCancellationOutcome } from "../enums/LateCancellationOutcome";
import { toSetCancellationPolicyRequest } from "../mappers/CancellationPolicyResponseMapper";
import { SetCancellationPolicyRequest } from "../contracts/SetCancellationPolicyRequest";

/** The sentence input for unsaved form values, resolving the fee from the Payment Type list. */
export const previewInput = (values: CancellationPolicyValues, paymentTypes: PaymentType[]): PolicySentenceInput => {
  const fee = paymentTypes.find((type) => type.id === values.feePaymentTypeId);
  return {
    cutoffHours: values.cutoffHours,
    lateOutcome: values.lateOutcome,
    fee: fee ? { name: fee.name, amountMinorUnits: fee.priceAmountMinorUnits, currency: fee.currency } : null,
  };
};

/** The request to save, or null when a fee policy has no fee chosen yet. */
export const toValidRequest = (values: CancellationPolicyValues): SetCancellationPolicyRequest | null =>
  values.lateOutcome === LateCancellationOutcome.ChargedFee && !values.feePaymentTypeId
    ? null
    : toSetCancellationPolicyRequest(values);
